<div class="font-bold mb-3" i18n>You have selected "ECIES Profile A" and "ECIES Profile B" for SUCI calculation schema.</div>
<div class="font-bold mb-3" i18n>"Home Network Public Keys" will be populated in each eSIM during data generation.</div>
